module.exports = __webpack_public_path__ + "e508f7480d33199ff39a66ad2ac69ef1.pdf";